import { createFileRoute } from '@tanstack/react-router'
import { FirstTimeLoginForm } from '../components/auth'
import { Container, Center } from '@mantine/core'

interface FirstTimeLoginSearch {
  email?: string
  returnTo?: string
}

export const Route = createFileRoute('/first-time-login')({
  validateSearch: (search: Record<string, unknown>): FirstTimeLoginSearch => {
    return {
      email: typeof search.email === 'string' ? search.email : undefined,
      returnTo: typeof search.returnTo === 'string' ? search.returnTo : '/'
    }
  },
  component: FirstTimeLoginComponent,
})

function FirstTimeLoginComponent() {
  const { email, returnTo } = Route.useSearch()
  
  return (
    <Container size="sm" style={{ minHeight: '100vh' }}>
      <Center style={{ minHeight: '100vh' }}>
        <FirstTimeLoginForm email={email} returnTo={returnTo} />
      </Center>
    </Container>
  );
}